export default {
  layout: {
    default: [
      '1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '; ς ε ρ τ υ θ ι ο π  [ ]',
      "α σ δ φ γ η ξ κ λ ; '",
      '{shift} ζ χ ψ ω β ν μ , . / {shift}',
      '@ {space}',
    ],
    shift: [
      '! " # $ % ^ & * ( ) _ + {bksp}',
      ': Σ Ε Ρ Τ Υ Θ Ι Ο Π { }',
      'Α Σ Δ Φ Γ Η Ξ Κ Λ : "',
      '{shift} Ζ Χ Ψ Ω Β Ν Μ < > ? {shift}',
      '@ {space}',
    ],
  },
};
